import { Modifier } from '@pizza-hut-us-development/client-core';

function getRecipeUpchargeAmount(options: Modifier[]) {
  const sizeOptions = options?.find((option) => option.id?.includes('size'));

  const crustModifiers = sizeOptions?.modifiers?.flatMap((mod) => mod.modifiers?.filter(((modifier) => modifier?.variantCode)));

  const lowestUpchargeAmount = crustModifiers?.reduce((acc, curr) => Math.min(curr?.upcharge ?? Infinity, acc), Infinity) || 0;

  return lowestUpchargeAmount === Infinity ? 0 : lowestUpchargeAmount;
}

function getSizeUpchargeAmount(size: Modifier, options: Modifier[]) {
  const recipeUpchargeAmount = getRecipeUpchargeAmount(options);
  let sizeUpchargeAmount: number = size?.modifiers?.reduce(
    (acc, curr) => Math.min(curr?.upcharge ?? Infinity, acc), Infinity
  ) || 0;

  sizeUpchargeAmount = sizeUpchargeAmount === Infinity ? 0 : sizeUpchargeAmount;

  return sizeUpchargeAmount - recipeUpchargeAmount;
}

function getCrustUpchargeAmount(crust: Modifier, options: Modifier[]) {
  const recipeUpchargeAmount = getRecipeUpchargeAmount(options);
  const sizeOptions = options?.find((option) => option.id?.includes('size'));
  const sizeForCrust = sizeOptions?.modifiers?.find((mod) => mod.modifiers?.some((modifier) => modifier?.variantCode === crust?.variantCode));
  const sizeUpchargeAmount = sizeForCrust ? getSizeUpchargeAmount(sizeForCrust, options) : 0;
  const variantUpchargeAmount = crust?.upcharge || 0;

  return variantUpchargeAmount - sizeUpchargeAmount - recipeUpchargeAmount;
}

function getToppingUpchargeAmount(crust: Modifier, numberOfSelectedToppings: number) {
  const toppingUpchargeLimits = crust?.upcharges
    ?.find((toppingUpcharges) => toppingUpcharges.slotCode.toLowerCase().includes('topping'))
    ?.weightPriceRanges;

  const toppingUpChargeAmount = toppingUpchargeLimits?.reduce((upCharge, priceRange) => {
    const isInPriceRangeStart = numberOfSelectedToppings > priceRange.rangeStart;
    const isInPriceRangeEnd = !priceRange.rangeEnd || numberOfSelectedToppings < priceRange.rangeEnd;
    if (isInPriceRangeStart && isInPriceRangeEnd) {
      const endOfRange = priceRange.rangeEnd || numberOfSelectedToppings;
      const toppingsInThisRange = endOfRange - priceRange.rangeStart;
      return upCharge + priceRange.price.amount * toppingsInThisRange;
    }

    return upCharge;
  }, 0) || 0;

  return toppingUpChargeAmount;
}

function getCheeseUpchargeAmount(crust: Modifier, cheese: Modifier) {
  const cheeseUpcharge = crust?.upcharges
    ?.find((cheeseUpcharges) => cheeseUpcharges.slotCode.toLowerCase().includes('cheese'))
    ?.modifiers.flatMap((modifier) => modifier.weights)
    .find((weight) => weight.modifierWeightCode === cheese?.weightCode && weight.price?.amount !== undefined)
    ?.price?.amount || 0;

  return cheeseUpcharge;
}

export {
  getRecipeUpchargeAmount, getSizeUpchargeAmount, getCrustUpchargeAmount, getToppingUpchargeAmount, getCheeseUpchargeAmount
};
